<tran-select
    [control]="control()"
    [label]="label() | translate"
    [placeholder]="placeholder() | translate"
    [errorMessage]="errorMessage() | translate"
    [submitted]="submitted()"
    [multi]="true"
    [hasSelectAll]="true"
    [selectAllLabel]="selectAllLabel() | translate"
    [options]="options()"
    [readonly]="readonly()"
/>
